import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param feedId Number
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (feedId, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_FEED_ID, {
        organisationId: organisationId,
        feedId: feedId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true });
    return request.execute();
});
